const compareNotes = (note1, note2) =>
  Date.parse(note1.created_at) > Date.parse(note2.created_at) ? 1 : 0;

const openNotesContent = actualContent => {
  if (typeof actualContent === "object") {
    return actualContent;
  }
  let noteContent;
  try {
    const content = JSON.parse(actualContent);
    if (typeof content === "string") {
      noteContent = {
        message: content,
      };
    } else if (typeof content === "object") {
      noteContent = { ...content };
    }
  } catch (error) {
    noteContent = { message: actualContent };
  }
  return noteContent;
};

const openNotesAnchor = actualAnchor => {
  let noteAnchor;
  try {
    const anchor = JSON.parse(actualAnchor);
    noteAnchor = anchor;
  } catch (error) {
    noteAnchor = actualAnchor;
  }
  return noteAnchor;
};

export const sortNotes = notesList => {
  if (notesList === undefined || notesList === null) {
    return [];
  }
  return notesList.sort((a, b) => compareNotes(a, b));
};

export const openNoteThread = noteThread => {
  if (noteThread.replies !== null) {
    noteThread.replies = noteThread.replies.map(note => {
      note.content = openNotesContent(note.content);
      return note;
    });
  }
  noteThread.content = openNotesContent(noteThread.content);
  noteThread.anchor = openNotesAnchor(noteThread.anchor);
  return noteThread;
};

export const openNotesThread = notesList => {
  if (notesList === undefined || notesList === null) {
    return [];
  }
  const openThreads = notesList.map(noteThread => openNoteThread(noteThread));
  return openThreads;
};



// WEBPACK FOOTER //
// ./src/actions/NotesActions/notesMethods.js